import { apiPathFunc } from "@api/util/apiPathFunc";
import type { IExtractParams } from "@/routes";
import { complete } from "@api/users/me/verifyUserEmail/complete/path";

const pathBase = `/users/me/verify-email/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const verifyUserEmail = {
  post: apiPathFunc(pathBase),
  complete,
};
